import { ConfirmDialog } from "plos/src/components/ConfirmDialog";
import { useTranslation } from "react-i18next";

interface TutorialWarningDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const TutorialWarningDialog = ({
  isOpen,
  onConfirm,
  onCancel,
}: TutorialWarningDialogProps) => {
  const { t } = useTranslation("squad");

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      label={t("tutorialWarning.dialogLabel", "Tutorial warning")}
      header={t("tutorialWarning.header", "Current players will be removed")}
      message={t(
        "tutorialWarning.message",
        "If you choose to Auto Pick with Tutorial now you will lose your current selection of players.",
      )}
      confirmButtonText={t("tutorialWarning.continue", "Continue to Auto Pick")}
      cancelButtonText={t("tutorialWarning.cancel", "Cancel")}
    />
  );
};

export default TutorialWarningDialog;
